import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import useStyles from 'isomorphic-style-loader/useStyles';

import { MaterialRenderer } from '../../components/MaterialRenderer/MaterialRenderer';
import { LessonQuitPrompt } from '../../components/Modals/LessonQuitPrompt/LessonQuitPrompt';
import { SlActions } from '../../services/ActionsService/sl-actions';
import { SlDataService } from '../../services/sl-data.service';
import { RequestType, ActionType } from '../../global-interface';
import { SlLEContext } from '../../global-constants';
import { getLETypeFromRoute } from '../../utils/helpers';
import { useContainerData } from '../../../../shared/public/SlHooks/useContainerData';
import { useQuery } from '../../../../shared/public/utilsPublic/utilsPublic';

import s from './LessonContainer.scss';
import { Container } from '../../../../symphony';
import { AINavbarService } from '../../../../navigation/private/services/ai-navbar.service';

interface ILessonContainerProps {
  isSkipAhead?: boolean;
}

export function LessonContainer({ isSkipAhead }: ILessonContainerProps): JSX.Element {
  useStyles(s);
  const { lesson$: lesson } = useContainerData(SlLEContext, SlDataService, [
    'lesson$',
  ]);
  const { hideNavbar } = Container.take('global', AINavbarService);

  const { materialId, courseAlias, pathAlias } = useParams();
  const query = useQuery();

  const { actions$ } = Container.take(SlLEContext, SlActions);

  useEffect(() => {
    hideNavbar();
    actions$.next({
      type: ActionType.OnLessonContainerMount,
      requestType: RequestType.Parallel,
      data: {
        type: getLETypeFromRoute({ courseAlias, pathAlias }),
        alias: courseAlias || pathAlias,
        materialId: Number(materialId),
        lessonPageIndex: Number(query.p),
        isSkipAhead,
      },
    });

    return () => {
      actions$.next({
        type: ActionType.OnLessonContainerUnmount,
        requestType: RequestType.Parallel,
      });
    };
  }, []);

  useEffect(() => {
    if (lesson && !!query.p) {
      actions$.next({
        type: ActionType.OnLessonPageIndexChange,
        requestType: RequestType.Parallel,
        data: {
          id: Number(materialId),
          lessonPageIndex: Number(query.p),
        },
      });
    }
  }, [query.p]);

  return lesson ? (
    <>
      <div
        sl-test-data="cmpLessonContainer"
        className="le-lesson-container"
      >
        <MaterialRenderer {...lesson} />
      </div>
      <LessonQuitPrompt />
    </>
  ) : null;
}
